import styled from 'styled-components';
import { CHART_BOX_LABEL_COLOR, CHART_BOX_GRID_COLOR } from '../../../utils/colors';

export const labelStyle = {
  fontSize: 11,
};

export const Label = styled.text`
  text-anchor: end;
  font-size: ${labelStyle.fontSize}px;
  fill: ${CHART_BOX_LABEL_COLOR};
`;

export const ValueLabel = styled.text`
  text-anchor: middle;
  font-size: ${labelStyle.fontSize}px;
  fill: ${CHART_BOX_LABEL_COLOR};
`;

export const Line = styled.line`
  stroke: ${CHART_BOX_GRID_COLOR};
  stroke-width: 1;
`;

export const BoxGroup = styled.g`
  transition: opacity 0.3s ease-in;
  opacity: ${({ isHoverActive, isGroupHovered }) => (isHoverActive && !isGroupHovered ? 0.3 : 1)};
`;
